import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../api';

const rs = (n) => '₹' + (Number(n) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

export default function useBillFilter(bills) {
  const [shift, setShift] = useState('all');
  const [pay, setPay] = useState('all');
  const [ranges, setRanges] = useState([]);
  useEffect(() => { api.get('/shifts/ranges').then((r) => setRanges(Array.isArray(r) ? r : [])).catch(() => {}); }, [bills]);

  const kindOf = useMemo(() => (b) => {
    const id = Number(b.id);
    const s = ranges.find((r) => id > Number(r.start_bill_id) && (r.end_bill_id == null || id <= Number(r.end_bill_id)));
    if (!s) return 'none';
    return /night|even/i.test(s.name || '') ? 'night' : 'morning';
  }, [ranges]);
  const modeOf = (b) => String(b.payment_mode || '').toLowerCase();

  const list = useMemo(() => (bills || []).filter((b) =>
    (shift === 'all' || kindOf(b) === shift) && (pay === 'all' || modeOf(b).includes(pay))), [bills, shift, pay, kindOf]);

  const active = list.filter((b) => String(b.status || 'active').toLowerCase() === 'active');
  const total = active.reduce((s, b) => s + (Number(b.total_amount) || 0), 0);
  const byMode = (m) => active.filter((b) => modeOf(b).includes(m)).reduce((s, b) => s + (Number(b.total_amount) || 0), 0);

  const chip = (on, color) => ({ padding: '7px 14px', borderRadius: 999, border: `1px solid ${on ? color : '#e4e2f3'}`, background: on ? color : '#fff',
    color: on ? '#fff' : '#3a3150', fontWeight: 700, fontSize: 13.5, cursor: 'pointer', font: 'inherit' });
  const Group = ({ label, value, set, opts }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 12, fontWeight: 800, color: '#8b84a0', letterSpacing: '.05em', marginRight: 2 }}>{label}</span>
      {opts.map(([v, t, c]) => <button key={v} type="button" style={chip(value === v, c)} onClick={() => set(v)}>{t}</button>)}
    </div>
  );
  const label = [shift !== 'all' ? (shift === 'night' ? 'Night' : shift === 'morning' ? 'Morning' : 'No shift') : null, pay !== 'all' ? pay.toUpperCase() : null].filter(Boolean).join(' · ') || 'All bills';

  const bar = (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center', justifyContent: 'space-between', margin: '6px 0 14px', padding: '12px 14px', borderRadius: 14, background: '#faf8ff', border: '1px solid #ece8f6' }}>
      <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
        <Group label="SHIFT" value={shift} set={setShift} opts={[['all', 'All', '#6948dc'], ['morning', '🌅 Morning', '#b45309'], ['night', '🌙 Night', '#5b21b6']]} />
        <Group label="PAYMENT" value={pay} set={setPay} opts={[['all', 'All', '#6948dc'], ['cash', '💵 Cash', '#15803d'], ['upi', '📱 UPI', '#1d4ed8'], ['card', '💳 Card', '#475569']]} />
      </div>
      <div style={{ textAlign: 'right', fontSize: 14 }}>
        <div><b>{label}:</b> {active.length} bills · <b style={{ color: '#5b3fd9', fontSize: 16 }}>{rs(total)}</b></div>
        {pay === 'all' && <div style={{ color: '#6b6280', fontSize: 13 }}>Cash {rs(byMode('cash'))} · UPI {rs(byMode('upi'))}{byMode('card') ? ` · Card ${rs(byMode('card'))}` : ''}</div>}
      </div>
    </div>
  );
  return { list, bar };
}
